import { Controller } from '@hotwired/stimulus'
import '../../src/css/modules/disqus.css'

export default class extends Controller {

  initialize() {
    if (typeof DISQUS == 'undefined') {
      // LEARN WHY DEFINING THESE VARIABLES IS IMPORTANT: https://disqus.com/admin/universalcode/#configuration-variables
      var disqus_config = function () {
        // Replace PAGE_URL with your page's canonical URL variable
        this.page.url = 'https://viedit.com' + this.data.get('url');
        // Replace PAGE_IDENTIFIER with your page's unique identifier variable
        this.page.identifier = this.data.get('identifier');
      };

      (function() { // DON'T EDIT BELOW THIS LINE
        var d = document, s = d.createElement('script');
        s.src = 'https://viedit.disqus.com/embed.js';
        s.setAttribute('data-timestamp', +new Date());
        (d.head || d.body).appendChild(s);
      })();
    } else {
      DISQUS.reset({
        reload: true,
        config: function() {
          this.page.url = 'https://viedit.com' + this.data.get('url')
          this.page.identifier = this.data.get('identifier')
        }
      })
    }
  }

}
